import Form from 'mlmi-library/components/form/v1/form'

$.fn.FormPayment = function() {
  let self = this
  self.form = undefined
  self.stripe_form = undefined

  self.handle_success = function(x) {
    if ('payment' in x) {
      self.initialize_stripe(x.payment)
    }
    $('input[name="form_id"]').val(x.form_id)
    self.form.getForm().fadeOut(300, function() {
      requestAnimationFrame(function() {
        self.stripe_form.fadeIn(300)
      })
    })
  }

  self.initialize_form = function() {
    self.form = new Form('.payment-form', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    self.find('input[name="montant"]').on('blur', function() {
      let value = parseFloat($(this).val().replaceAll(',', '.').replaceAll(' ', '').replaceAll(' ', ''))
      if (!value || isNaN(value) || value == undefined || value <= 0) {
        value = ''
      } else {
        value = value.toLocaleString('fr-CA', {
          style: 'currency',
          currency: 'CAD',
          currencyDisplay: 'symbol',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).replace('CA', '').trim()
      }
      $(this).val(value)
    })
  }

  self.update_fields = function() {
    //
  }

  self.initialize_stripe = function(client_secret) {
    const stripe = Stripe(culturemontreal_l10n.stripe_pk)
    const options = {
      clientSecret: client_secret,
      appearance: {
        theme: 'flat',
        variables: {
          colorDanger: '#ef0000',
          fontFamily: '"PxGroteskLight", system-ui, sans-serif',
        },
      },
      locale: 'fr',
    };

    self.stripe_form = $('#stripe-payment-form')

    const elements = stripe.elements(options),
    paymentElement = elements.create('payment')
    paymentElement.mount('#payment-element')
    const form = self.stripe_form.get(0)
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const {error} = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: culturemontreal_l10n.payment_url + '?confirmation=1',
        },
      });

      if (error) {
        const messageContainer = document.querySelector('#stripe-error-message');
        messageContainer.textContent = error.message;
      }
    });
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

export default {
  init() {
    $('.payment-form').each(function() {
      $(this).FormPayment()
    })
  },
}
